import { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import AnimationPage from 'components/AnimationPage';
import WorkPreview from 'components/WorkPreview';
// import Filter from 'components/Filter';
import "assets/styles/Work.css";
import Seo from 'components/Seo';
import animations from 'utils/animations';
import { motion } from 'framer-motion';

export default function Work() {
  const works = useLoaderData();
  const [data] = useState(works);
  const { opacity } = animations.components;
  /*const tags = [...new Set(works.flatMap(work => work.tags))];
  const [selectedTags, setSelectedTags] = useState(new Set());

  const filterWorks = (tag) => {
    if (selectedTags.has(tag)) {
      setSelectedTags(prev => {
        const newSet = new Set(prev);
        newSet.delete(tag)
        return newSet;
      });
    } else {
      setSelectedTags(prev => {
        const newSet = new Set(prev);
        newSet.add(tag)
        return newSet;
      });
    }
  };

  useEffect(() => {
    if (selectedTags.size > 0) {
      const tags = Array.from(selectedTags);
      const filteredData = data.filter(work => 
        tags.every(tag => work.tags.includes(tag))
      );
      setData(filteredData);
    } else {
      setData(works);
    }
  }, [selectedTags]);*/

  return (
    <AnimationPage>
      <Seo title='Work - Kollectiff' />
      <main>
        <div className="container our-works">
          <motion.h1
            className="k-title-sm md:k-title-md xl:k-title-lg text-center"
            {...opacity}
            transition={{ delay: 0.3 }}
          >
            Our Works
          </motion.h1>

          <div className="our-works-list">
            <AnimatePresence>
              {data.map((work, index) => (
                <WorkPreview
                  section={true}
                  key={index}
                  media={work.media}
                  mediaHover={work.mediaHover}
                  title={work.title}
                  description={work.description}
                  link={work.slug}
                  tags={work.tags} />
              ))}
            </AnimatePresence>
          </div>
        </div>
      </main>
    </AnimationPage>
  );
}
